<template>
  <div class="paginationnew">
    <button :disabled="pageNo == 1" ref="preref" @click="pre()">
      <i class="el-icon-arrow-left"></i>
    </button>

    <button
      v-if="startNumAndEndNum.start > 1"
      @click="$emit('getPageNo', 1)"
      :class="{ active: pageNo == 1 }"
    >
      1
    </button>
    <button v-if="startNumAndEndNum.start > 2" @click="changestartend(1)">
      <i
        @mouseenter="showLeft = true"
        @mouseleave="showLeft = false"
        :class="showLeft ? 'el-icon-d-arrow-left' : 'el-icon-more'"
      ></i>
    </button>

    <!-- 连续的页码 -->
    <button
      v-for="(page, index) in startNumAndEndNum.end"
      :key="index"
      v-if="page >= startNumAndEndNum.start"
      @click="$emit('getPageNo', page, 2)"
      :class="{ active: pageNo == page }"
    >
      {{ page }}
    </button>

    <button
      v-if="startNumAndEndNum.end < totalPage - 1"
      @click="changestartend(2)"
    >
      <i
        @mouseenter="showRight = true"
        @mouseleave="showRight = false"
        :class="showRight ? 'el-icon-d-arrow-right' : 'el-icon-more'"
      ></i>
    </button>
    <button
      v-if="startNumAndEndNum.end < totalPage"
      @click="$emit('getPageNo', totalPage)"
      :class="{ active: pageNo == totalPage }"
    >
      {{ totalPage }}
    </button>
    <button ref="nextref" @click="next()" :disabled="pageNo == totalPage">
      <i class="el-icon-arrow-right"></i>
    </button>
    <span class="jump"
      >前往
      <div style="width: 50px; height: 24px; margin: 0 4px">
        <el-input
          v-model="gotopage"
          type="number"
          autocomplete="off"
          :min="1"
          :max="total"
          @keyup.enter.native="goto()"
        ></el-input>
      </div>
      页</span
    >
    <!-- <button style="margin-left: 30px">共 {{ total }} 条</button> -->
  </div>
</template>
 
<script>
export default {
  name: "SelPagination",
  data () {
    return {
      startNumAndEndNum: { start: 1, end: 7 },
      gotopage: 1,
      showLeft: false,
      showRight: false,
      isHandlingKey: false // 防止重复处理键盘事件的标志
    }
  },
  props: { pageNo: { type: Number, default: 1 }, pageSize: { type: Number, default: 1 }, total: { type: Number, default: 1 }, continues: { type: Number, default: 8 }, start: { type: Number }, end: { type: Number }, isbofangqi: { type: Number, default: 3 }, ismovepage: { type: Number, default: 1 } },

  computed: {
    // *计算总共多少页,也就是最后一页（需要向上取整Math.ceil）
    totalPage () {
      return Math.ceil(this.total / this.pageSize)
    },


  },

  mounted () {
    // this.startNumAndEndNum1()

    this.startNumAndEndNum.start = this.start
    this.startNumAndEndNum.end = this.end
    this.$bus.$on("startNumAndEndNum1", (gotopage) => {
      this.startNumAndEndNum1(gotopage)
    })
    if (this.isbofangqi == 1) {
      window.addEventListener('keydown', this.handleKeyDown)
    }




  },
  methods: {
    handleKeyDown (event) {
      // 防止重复处理
      if (this.isHandlingKey) return

      this.isHandlingKey = true
      setTimeout(() => {
        this.isHandlingKey = false
      }, 100)

      // 左方向键
      if (event.key === "ArrowLeft" && !this.isDisabled("prev")) {
        this.pre()
        event.preventDefault()
      }
      // 右方向键
      if (event.key === "ArrowRight" && !this.isDisabled("next")) {
        this.next()
        event.preventDefault()
      }
    },
    // 判断按钮是否禁用
    isDisabled (type) {
      if (type === "prev") return this.pageNo === 1
      if (type === "next") return this.pageNo === this.totalPage
      return false
    },
    next () {
      this.$emit('getPageNo', this.pageNo + 1)
      this.startNumAndEndNum1(this.pageNo + 1)
    },
    pre () {
      this.$emit('getPageNo', this.pageNo - 1)
      this.startNumAndEndNum1(this.pageNo - 1)
    },
    // *计算出连续页码的起始数字与结束的数字【连续的页码数字：至少是5】
    startNumAndEndNum1 (gotopage) {


      let { continues, pageNo, totalPage } = this // 解构了
      // console.log(gotopage, pageNo, totalPage, this.pageSize, this.total, 'gotopage')

      if (gotopage != pageNo) {
        pageNo = parseInt(gotopage)
      }
      if (gotopage < 1) {
        pageNo = 1
      }

      if (gotopage > totalPage) {
        pageNo = totalPage
      }
      // console.log(gotopage, pageNo, 'gotopage')

      // console.log(continues,pageNo,totalPage,'totalPage')
      // 先定义两个变量存储起始数字与结束数字
      let start = 0,
        end = 0
      // *连续页码数字是5【至少5页】，如果出现不正常现象【不够5页，即总页数 < 连续页码5】
      if (continues > totalPage) {
        start = 1
        end = totalPage
      } else {
        // 正常现象【连续的页码5，但是你的总页数一定是大于5的】 parseInt()返回一个十进制的整数【一个数字的参数可同Math.floor】
        start = pageNo - parseInt(Math.floor(continues / 2))
        end = pageNo + parseInt(Math.floor(continues / 2))
        // 把出现不正常的现象【start数字出现0|负数，continues=5，pageNo=1、2的时候】
        if (start < 1) {
          start = 1
          end = continues
        }
        // 把出现不正常的现象【end数字大于总页码，continues=5，totalPage=30，pageNo=29、30的时候】
        if (end > totalPage) {
          start = totalPage - continues + 1
          end = totalPage
        }

      }
      this.startNumAndEndNum = { start, end }
      // this.$emit("changeStartEnd", start, end)
    },
    changestartend (type) {
      let start = 0,
        end = 0
      if (type == 2) {
        end = this.startNumAndEndNum.end + this.continues
        start = this.startNumAndEndNum.end + 1
        if (end > this.totalPage) {
          end = this.totalPage
        }
      } else if (type == 1) {
        end = this.startNumAndEndNum.end - this.continues
        start = this.startNumAndEndNum.start - this.continues
        if (start < 0) {
          start = 1
        }
      }
      this.startNumAndEndNum = { start, end }
      this.$emit("changeStartEnd", start, end)
    },
    goto () {
      if (parseInt(this.gotopage) > this.total) {
        this.gotopage = this.total
      }
      this.$emit('getPageNo', parseInt(this.gotopage))
      // console.log(this.ismovepage, 'this.ismovepage.sel')
      if (this.ismovepage != 2) {
        this.startNumAndEndNum1(parseInt(this.gotopage))
      }

    }
  },
  watch: {

    pageNo (newval, oldval) {
      // console.log(newval, oldval, 'oldval')

      this.gotopage = newval
      this.goto()
      // this.startNumAndEndNum1()
    },
    pageSize () {
      this.startNumAndEndNum1()

    },
    start () {
      // console.log(this.start, 'start')
      this.startNumAndEndNum.start = this.start
      this.startNumAndEndNum.end = this.end

    },
  },
  beforeDestroy () {
    // 移除键盘事件监听器，防止内存泄漏
    window.removeEventListener('keydown', this.handleKeyDown)
  },
};
</script>
 
<style lang="less" scoped>
/deep/input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
/deep/.el-input__inner {
  height: 24px;
  line-height: 24px;
  text-align: center;
  padding: 0 2px;
}
/deep/input::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
}

/deep/input[type="number"] {
  -moz-appearance: textfield;
}
// /deep/.el-pagination__editor{
//       line-height: 18px;
//     padding: 0 2px;
//     height: 28px;
//     margin: 0 2px;
// }
.jump {
  font-size: 13px;
  height: 24px;
  line-height: 24px;
  display: flex;
}
.paginationnew {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  button {
    margin: 0 5px;
    // background-color: #f4f4f5;
    // color: #606266;
    outline: none;
    border-radius: 2px;
    padding: 0 4px;
    vertical-align: top;
    display: inline-block;
    font-size: 13px;
    min-width: 30px;
    height: 24px;
    line-height: 24px;
    cursor: pointer;
    box-sizing: border-box;
    text-align: center;
    border: 0;

    // 选择带有disabled属性的所有元素
    &[disabled] {
      color: #c0c4cc;
      cursor: not-allowed;
    }

    &.active {
      cursor: default;
      // background-color: #409eff;
      color: #409eff;
    }
    &:hover {
      // background-color: #409eff;
      color: #409eff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/selpagination.vue